import React from 'react';
import { ActivityIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full py-24 px-4 bg-white" data-id="element-185">
      <div className="max-w-3xl mx-auto" data-id="element-186">
        <div className="text-center mb-12" data-id="element-187">
          <span className="text-brand-purple font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-188">
            La ciencia detrás
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-slate" data-id="element-189">
            ¿Por qué funciona?
          </h2>
        </div>

        <div className="bg-brand-slate text-white rounded-3xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-190">
          <div className="absolute top-0 right-0 opacity-10 transform translate-x-1/4 -translate-y-1/4" data-id="element-191">
            <ActivityIcon className="w-64 h-64" aria-hidden="true" data-id="element-192" />
          </div>

          <div className="relative z-10" data-id="element-193">
            <p className="text-xl md:text-2xl font-serif leading-relaxed text-brand-cream" data-id="element-194">
              "A diferencia de los libros de psicología teórica, este manual se
              enfoca en la respuesta fisiológica. Cuando exhalas el doble de
              tiempo de lo que inhalas, tu ritmo cardíaco disminuye por
              necesidad biológica. Es un 'hack' al sistema nervioso probado por
              miles de personas en situaciones de alto estrés."
            </p>
          </div>
        </div>
      </div>
    </section>;
}